import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import {FcTreeStructure} from "react-icons/fc"
import {BsFillPinAngleFill,BsPersonLinesFill} from "react-icons/bs"
import {MdOutlineSupervisorAccount} from "react-icons/md"
const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function View(props) {
  const { open, onClose, onProspektChoose, chooseProspektId } = props;
  const [prospekt, setProspekt] = useState({});
  const [structureList, setStructureList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { pin ,fullName,status,duty,supervisor} = prospekt;

  useEffect(() => {
    setIsLoading(true);
    onProspektChoose(chooseProspektId)
      .then((res) => {
        setProspekt(res.data);
        setStructureList(res.data.structureList);

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseProspektId, onProspektChoose]);

  const classes = useStyles();


  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">İnsan resurslarının  detalları</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />

      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <div className="drawer-body">
          <Card className={classes.card}>
            <CardHeader
              title="Ümumi informasiya"
              className="bg-secondary text-dark h6 p-3"
              disableTypography
            />
            <CardHeader
              avatar={
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Address-card.svg"
                  )}
                  className="icon-primary"
                />
              }
              title={fullName }
              subheader="A.S.A"
              className="p-3"
            />
           
            <CardHeader
            avatar={
              <BsFillPinAngleFill
                className="icon-primary"
              />
            }
              title={pin}
              subheader="Fin kod"
              className="p-3"
            />
             <CardHeader
            avatar={
              <BsPersonLinesFill
                className="icon-primary"
              />
            }
              title={duty}
              subheader="Vəzifə"
              className="p-3"
            />
               <CardHeader
              avatar={
                <MdOutlineSupervisorAccount
                  className="icon-primary"
                />
              }
              title={supervisor}
              subheader="Birbaşa rəhbər"
              className="p-3"
            />
            
            {structureList.map((row, index) => {
              return (
                <CardHeader
                avatar={
                  <FcTreeStructure
                    className="icon-primary"
                  />
                }
                title={row.name}
                subheader={row.type === "DIVISION" ? "Bölmə" :row.type === "PORTFEL" ? "Portfel" :row.type === "WORK_PLACE" ? "İş yeri" : row.type === "BRANCH" ? "Şöbə" : row.type === "DEPARTMENT" ? "Departament" :row.type === "COMPANY" ? "Şirkət"  : row.type === "DIRECTORATE" && "Direktorluq" }
                className="p-3"
              />
              );
            })} 
      <CardHeader
      avatar={
        <SVG
          src={toAbsoluteUrl("/media/svg/icons/Code/Lock-circle.svg")}
          className="icon-primary"
        />
      }
      title={status === "ACTIVE"
                            ? "Aktiv"
                            :  status=== "INACTIVE"
                            ? "Deaktiv"
                            : "-"}
      subheader="Vəziyyət"
      className="p-3"
    />
          </Card>
        </div>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </div>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      className="drawer--fixed"
    >
      {sideList("right")}
    </Drawer>
  );
}
